import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTourismData } from '../../context/TourismContext'

function AboutOne() {
    const { aboutSection, loading, fetchAboutSection } = useTourismData();

    useEffect(() => {
        fetchAboutSection();
    }, [fetchAboutSection]);

    // Use dynamic data from API or fallback to defaults while loading
    const aboutData = aboutSection?.results?.[0] || {
        subtitle: "Let's Go Together",
        title: "Plan Your Trip With us",
        description: "There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words which don't look even slightly.",
        image1: "/assets/img/normal/about_1_1.jpg",
        image2: "/assets/img/normal/about_1_2.jpg",
        image3: "/assets/img/normal/about_1_3.jpg",
        feature1_icon: "map3.svg",
        feature1_title: "Exclusive Trip",
        feature1_description: "There are many variations of passages of available but the majority.",
        feature2_icon: "guide.svg",
        feature2_title: "Professional Guide",
        feature2_description: "There are many variations of passages of available but the majority.",
        button_text: "Learn More",
        button_link: "/about"
    };

    return (
        <div
            className="about-area position-relative overflow-hidden space"
            id="about-sec"
        >
            <div className="container shape-mockup-wrap">
                <div className="row">
                    <div className="col-xl-6">
                        <div className="img-box1">
                            <div className="img1">
                                <img 
                                    src={aboutData.image1.startsWith('http') ? aboutData.image1 : `/assets/img/normal/about_1_1.jpg`} 
                                    alt="About" 
                                />
                            </div>
                            <div className="img2">
                                <img 
                                    src={aboutData.image2?.startsWith('http') ? aboutData.image2 : `/assets/img/normal/about_1_2.jpg`} 
                                    alt="About" 
                                />
                            </div>
                            <div className="img3">
                                <img 
                                    src={aboutData.image3?.startsWith('http') ? aboutData.image3 : `/assets/img/normal/about_1_3.jpg`} 
                                    alt="About" 
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="ps-xl-4 ms-xl-2">
                            <div className="title-area mb-20 pe-xl-5 me-xl-5">
                                <span className="sub-title style1">{aboutData.subtitle}</span>
                                <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                                    {aboutData.title}
                                </h2>
                                <p className="sec-text mb-30">
                                    {aboutData.description}
                                </p>
                            </div>
                            <div className="about-item-wrap">
                                <div className="about-item">
                                    <div className="about-item_img">
                                        <img src={`/assets/img/icon/${aboutData.feature1_icon}`} alt="" />
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">{aboutData.feature1_title}</h5>
                                        <p className="about-item_text">
                                            {aboutData.feature1_description}
                                        </p>
                                    </div>
                                </div>
                                <div className="about-item">
                                    <div className="about-item_img">
                                        <img src={`/assets/img/icon/${aboutData.feature2_icon}`} alt="" />
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">{aboutData.feature2_title}</h5>
                                        <p className="about-item_text">
                                            {aboutData.feature2_description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-35">
                                <Link to={aboutData.button_link} className="th-btn style3 th-icon">
                                    {aboutData.button_text}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="shape-mockup shape1 d-none d-xl-block"
                    style={{
                        top: "12%",
                        left: "-16%",
                    }}
                >
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape2 d-none d-xl-block"
                    style={{
                        top: "20%",
                        left: "-16%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape3 d-none d-xl-block"
                    style={{
                        top: "14%",
                        left: "-10%",
                    }}
                >
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup about-shape movingX d-none d-xxl-block"
                    style={{
                        bottom: "0%",
                        right: "-11%",
                    }}
                >
                    <img src="/assets/img/normal/about-slide-img.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup about-rating d-none d-xxl-block"
                    style={{
                        bottom: "50%",
                        right: "-20%",
                    }}
                >
                    <i className="fa-sharp fa-solid fa-star" />
                    <span>4.9k</span>
                </div>
                <div
                    className="shape-mockup about-emoji d-none d-xxl-block"
                    style={{
                        bottom: "25%",
                        right: "5%",
                    }}
                >
                    <img src="/assets/img/icon/emoji.png" alt="" />
                </div>
            </div>
        </div>

    )
}

export default AboutOne
